import { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { urlGetNextCall, actualDateFormmater} from '../../helpers';
import { NextCallTable } from './components/NextCallTable';
import { Stack } from '@mui/material';
import { TitlePage } from "../../components/TitlePage";
import { NextCallFilter } from "./components/NextCallFilter";

export const NextCall = () => {

    const { data, loading } = useFetch(urlGetNextCall, 'GET');
    const [dataTable, setDataTable] = useState({});
    const [copyArray, setCopyArray] = useState({});

    useEffect(() => {
        let dataArray = [];
        data?.forEach(element => {
            try {
                const contacts = JSON.parse(element.client.contacts);
                // Buscar el contacto que coincida con element.contact
                const contactData = contacts.find(c => c.contactName === element.contact);

                // Si no se encuentra, usar el primer contacto o valores por defecto
                const contactTel = contactData?.contactTel || contacts[0]?.contactTel || '';
                const contactEmail = contactData?.contactEmail || contacts[0]?.contactEmail || '';

                if (element.dateCall >= actualDateFormmater(new Date().toLocaleDateString())) {
                    dataArray.push({
                        ...element,
                        'tel': contactTel,
                        'email': contactEmail,
                        'callMade': element.callMade === 'true' ? true : false
                    });
                }
            } catch (error) {
                console.error('Error procesando contacto para elemento:', element.id, error);
                // Agregar el elemento sin datos de contacto en caso de error
                if (element.dateCall >= actualDateFormmater(new Date().toLocaleDateString())) {
                    dataArray.push({
                        ...element,
                        'tel': '',
                        'email': '',
                        'callMade': element.callMade === 'true' ? true : false
                    });
                }
            }
        });

        setDataTable(dataArray)
        setCopyArray(dataArray)
    }, [data])


    return (
        <Stack width='100%' alignItems='center'>
            <Stack width='95%' alignItems='center' mt='2rem'>
                <TitlePage title={'Próximas llamadas'} subtitle={'Llamadas para confirmar presupuesto'} />
            </Stack>
            <Stack width='95%' >
                <NextCallFilter setFilterArray={setCopyArray} copyArray={dataTable}/>
                {
                    (!loading && data)
                        ? <NextCallTable data={copyArray} />
                        : <p>Cargando</p>
                }
            </Stack>
        </Stack>
    )
}

